import { useMonthPeriodStore } from '../../store/useMonthPeriodStore'
import { Spinner } from '@heroui/react'
import { StationPanelLinePhoto } from '../panels/StationPanelLinePhoto'
import { MonthPeriodPicker } from './shared/MonthPeriodPicker'
import { HlyGrid } from './shared/HlyGrid'
import { TimeZonePicker } from './shared/TimeZonePicker'
import { TableOrientationToggle } from './shared/TableOrientationToggle'
import { useTableOrientationStore } from '../../store/useTableOrientationStore'
import { useHlyOneMonthData } from '../../hooks/useHlyOneMonthData'
import { TEMP_SCALE } from './shared/weatherUtils'

const SLUG = 'hly-temp'


function tempCellStyle(value) {
  if (value == null) return null
  const entry = TEMP_SCALE.find(e => value >= e.min)
  return entry ? { bg: entry.bg, text: entry.text } : null
}

function TempLegend() {
  return (
    <div className="shrink-0 flex flex-col gap-0.5">
      <div className="text-xs font-semibold text-gray-400 uppercase tracking-wide mb-1">°C</div>
      {TEMP_SCALE.map(({ label, bg }) => (
        <div key={label} className="flex items-center gap-1.5 text-xs whitespace-nowrap">
          <span className="inline-block w-4 h-4 rounded-sm shrink-0" style={{ backgroundColor: bg }} />
          <span className="text-gray-600">{label}</span>
        </div>
      ))}
    </div>
  )
}

export function HlyOneMonthTempView({ station }) {
  const { year, month, setYear, setMonth } = useMonthPeriodStore()
  const orientation = useTableOrientationStore((s) => s.getOrientation(SLUG))

  const { dataMap, localToUtcMap, days, isLoading, isError, error } = useHlyOneMonthData(station?.gh_id, year, month)

  return (
    <div className="flex flex-col h-full">
      {/* Header */}
      <div className="p-4 border-b border-gray-200 bg-white flex flex-col gap-3">
        {station && <StationPanelLinePhoto station={station} />}
        <div className="flex items-center justify-between gap-3">
          <MonthPeriodPicker
            year={year}
            month={month}
            onYearChange={setYear}
            onMonthChange={setMonth}
            obsType="HLY"
          />
          <div className="flex items-center gap-3">
            <TimeZonePicker />
            <TableOrientationToggle slug={SLUG} />
          </div>
        </div>
      </div>

      {/* Grid area */}
      <div className="flex-1 min-h-0 p-4 flex flex-col">
        {isLoading && (
          <div className="flex items-center gap-2 text-sm text-gray-500">
            <Spinner size="sm" /> Načítání dat…
          </div>
        )}
        {isError && (
          <p className="text-red-500 text-sm">{error?.message ?? 'Chyba při načítání dat'}</p>
        )}
        {!isLoading && !isError && (
          <div className="flex-1 min-h-0 flex gap-6">
            <div className="flex-1 min-w-0 min-h-0">
              <HlyGrid year={year} month={month} days={days} dataMap={dataMap} localToUtcMap={localToUtcMap} getCellStyle={tempCellStyle} orientation={orientation} />
            </div>
            <TempLegend />
          </div>
        )}
      </div>
    </div>
  )
}
